"use strict";
const React = require('react');
const react_redux_1 = require('react-redux');
const react_router_1 = require('react-router');
const perm_identity_1 = require('material-ui/svg-icons/action/perm-identity');
const authActions = require('../actions/auth');
const actionTypes = require('../actionTypes');
const routes = require('../utils/routes');
const Flex_1 = require('./Flex');
const SvgIcons = require('./SvgIcons');
const Navigation_1 = require('./Navigation');
const RaisedButton_1 = require('./RaisedButton');
const Screen_1 = require('./Screen');
const providerNames = {
    'facebook.com': 'Facebook',
    'google.com': 'Google',
    'twitter.com': 'Twitter',
};
const mapStateToProps = (state) => ({
    auth: state.auth,
});
const mapDispatchToProps = (dispatch) => ({
    signInWithProvider: (providerId) => {
        dispatch(authActions.signInWithProvider(providerId));
    },
    cancelLogin: () => {
        dispatch(authActions.cancelLogin());
    },
});
class LoginScreen extends React.Component {
    constructor() {
        super(...arguments);
        this.handleLoginTap = (providerId) => {
            this.props.signInWithProvider(providerId);
        };
    }
    componentWillReceiveProps(nextProps) {
        if (!this.props.auth.user && nextProps.auth.user) {
            const redirectTo = nextProps.location.query.redirect || routes.tasks();
            react_router_1.browserHistory.replace(redirectTo);
        }
    }
    render() {
        return (React.createElement(Screen_1.Screen, null, 
            React.createElement(Navigation_1.default, {title: "My Minutes"}), 
            React.createElement(Screen_1.ScreenContent, {style: style.screenContent}, this.renderBody())));
    }
    renderBody() {
        if (this.props.auth.status === actionTypes.ATTEMPT_LOGIN) {
            return this.renderLoggingIn();
        }
        else if (this.props.auth.status === actionTypes.ACCOUNT_EXISTS) {
            return this.renderAccountExists();
        }
        else {
            return (React.createElement(Flex_1.Column, null, 
                React.createElement("h3", {style: style.heading}, "Hey there!"), 
                React.createElement("p", {style: style.paragraph}, "Log in to start setting goals for your time!"), 
                React.createElement(RaisedButton_1.default, {label: "Log in with Facebook", icon: React.createElement(SvgIcons.Facebook, null), onTouchTap: () => this.handleLoginTap('facebook.com'), primary: true, style: style.button}), 
                React.createElement(RaisedButton_1.default, {label: "Log in with Google", icon: React.createElement(SvgIcons.Google, null), onTouchTap: () => this.handleLoginTap('google.com'), primary: true, style: style.button}), 
                React.createElement(RaisedButton_1.default, {label: "Log in with Twitter", icon: React.createElement(SvgIcons.Twitter, null), onTouchTap: () => this.handleLoginTap('twitter.com'), primary: true, style: style.button})));
        }
    }
    renderLoggingIn() {
        return (React.createElement(Flex_1.Column, {style: style.loggingInContainer}, 
            React.createElement(perm_identity_1.default, {style: style.loggingInIcon}), 
            React.createElement("h3", null, "Logging in...")));
    }
    renderAccountExists() {
        const { requestedProviderId, existingProviderId } = this.props.auth;
        const requestedProvider = providerNames[requestedProviderId];
        const existingProvider = providerNames[existingProviderId];
        return (React.createElement(Flex_1.Column, null, 
            React.createElement("h3", {style: style.heading}, "You already have an account"), 
            React.createElement("p", {style: style.paragraph}, 
                "You already used ", 
                existingProvider, 
                " to log in." + ' ' + "Log in with ", 
                existingProvider, 
                " and link your ", 
                requestedProvider, 
                " account?"), 
            React.createElement(RaisedButton_1.default, {label: `Log in with ${existingProvider}`, icon: SvgIcons.renderAuthProviderIcon(existingProviderId), onTouchTap: () => this.handleLoginTap(existingProviderId), primary: true, style: style.button}), 
            React.createElement(RaisedButton_1.default, {label: "Cancel", onTouchTap: this.props.cancelLogin, style: style.button})));
    }
}
const style = {
    screenContent: {
        alignItems: 'center',
        display: 'flex',
        height: `calc(100vh - ${Navigation_1.style.appBar.height} - 32px)`,
        justifyContent: 'center',
        paddingTop: '32px',
    },
    heading: {
        margin: '0 0 16px',
    },
    paragraph: {
        margin: '0 0 48px',
    },
    button: {
        marginBottom: '20px',
    },
    loggingInContainer: {
        alignItems: 'center',
        height: '100%',
        justifyContent: 'center',
    },
    loggingInIcon: {
        height: 56,
        width: 56,
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = react_redux_1.connect(mapStateToProps, mapDispatchToProps)(LoginScreen);



/** WEBPACK FOOTER **
 ** ./src/components/LoginScreen.tsx
 **/